import { css } from '@emotion/css'
import appSettings from '../../app/app-settings'

const homeHeaderCss = {
  wrapper: () => css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: appSettings.navFullHeight,
    height: 460, // +100
    gap: 30,
    background: `url("assets/background.png")`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    position: "relative",

    [appSettings.mediaQueries.xxlTablet]: {
      height: 550,
    },

    [appSettings.mediaQueries.largeDesktop]: {
      height: 650,
      gap: 55,
    },

    [appSettings.mediaQueries.smallTablet]: {
      height: 370,
    },
  }),

  homePhoto: () => css({
    position: "absolute",
    objectFit: "cover",
    objectPosition: "50% 90%",
    height: "100%",
    width: "100%",

    [appSettings.mediaQueries.largeDesktop]: {
      
    objectPosition: "50% 85%",
    },
  }),

  title: () => css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "baseline",
    gap: 30,
    zIndex: 10,
    marginTop: 140,

    [appSettings.mediaQueries.xxlTablet]: {
      marginTop: 240,
    },

    [appSettings.mediaQueries.mobile]: {
      flexDirection: "column",
      alignItems: "center",
      gap: 0,
      marginTop: 70,
    },
  }),

  name: () => css({
    fontFamily: "AlexBrushRegular",
    fontSize: 90,
    color: appSettings.colors.whiteColor,
    textShadow: `2px 2px 6px rgba(0, 0, 0, 0.3)`,

    [appSettings.mediaQueries.largeDesktop]: {
      fontSize: 110,
    },

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 70,
    },

    [appSettings.mediaQueries.mobile]: {
      fontSize: 60,
    },
  }),

  ampersand: () => css({
    fontFamily: "ParisienneRegular",
    fontSize: 60,
    color: appSettings.colors.whiteColor,
    textShadow: `2px 2px 6px rgba(0, 0, 0, 0.3)`,

    [appSettings.mediaQueries.largeDesktop]: {
      fontSize: 80,
    },

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 40,
    },

    [appSettings.mediaQueries.mobile]: {
      fontSize: 30,
    },
  }),

  date: () => css({
    fontFamily: "CinzelRegular",
    fontSize: 65,
    color: appSettings.colors.whiteColor,
    textShadow: `2px 2px 6px rgba(0, 0, 0, 0.3)`,
    zIndex: 10,

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 40,
    }
  }),

  countdownTimer: () => css({
    display: "flex",
    justifyContent: "center",
    gap: 30,
    backgroundColor: "white",
    boxShadow: `2px 2px 12px ${appSettings.colors.blackShadow}`,
    zIndex: 10,

    [appSettings.mediaQueries.largeDesktop]: {
      gap: 35,
    },

    [appSettings.mediaQueries.mobile]: {
      width: "100%",
      justifyContent: "space-between",
      gap: 0,
      marginTop: -5,
    },
  }),

  countdownTimerItem: () => css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    width: 90,
    height: 90,

    [appSettings.mediaQueries.largeDesktop]: {
      width: 120,
      height: 120,
    },

    [appSettings.mediaQueries.smallTablet]: {
      width: 70,
      height: 70,
    },

    [appSettings.mediaQueries.mobile]: {
      width: "20%",
      height: 70,
    },
  }),

  timerCount: () => css({
    fontFamily: "CinzelRegular",
    fontSize: 25,

    [appSettings.mediaQueries.largeDesktop]: {
      fontSize: 30,
    },

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 20,
    },

    [appSettings.mediaQueries.mobile]: {
      fontSize: 18,
    },
  }),

  timerName: () => css({
    fontFamily: "CinzelRegular",
    fontSize: 15,
    color: appSettings.colors.blueColor,

    [appSettings.mediaQueries.largeDesktop]: {
      fontSize: 18,
    },

    [appSettings.mediaQueries.smallTablet]: {
      fontSize: 14,
    },
  }),
}

export default homeHeaderCss
